module.exports = __webpack_public_path__ + "static/media/icon-phone.7c5cc04d.svg";